import type { PreviousEducationSchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { previousEducationSchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import Button from '$/components/elements/Button';
import Container from '$/components/elements/Container';
import diplomasList from '$/components/elements/Questions/lists/diplomasList';
import SelectAnswerInputQuestion from '$/components/elements/Questions/SelectAnswerInputQuestion';
import SliderInputQuestion from '$/components/elements/Questions/SliderInputQuestion';
import useElb from '$/hooks/useElb';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

const PreviousEducation = () => {
  const { elbProps } = useElb();
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<PreviousEducationSchemaType>({
    mode: 'onTouched',
    resolver: yupResolver(previousEducationSchema),
    defaultValues: state,
  });

  const onSubmit = (payload: PreviousEducationSchemaType) => {
    dispatch({
      type: 'set',
      payload,
    });
    setCurrentStep('signUp', 0);
  };

  return (
    <StudentQuestion noLimitHeight>
      <Container>
        <SelectAnswerInputQuestion
          title={'Was für einen Schulabschluss hast du?'}
          list={diplomasList}
          control={control}
          name={'previousEducation'}
          maxElements={1}
        />
        <SliderInputQuestion
          title={'Wie war dein Notendurchschnitt?'}
          control={control}
          name={'schoolNote'}
          step={0.1}
          min={1}
          max={4}
          numberInput
        />
        <StudentQuestion.Section columns="1fr">
          <Button
            title="Weiter"
            disabled={!isValid}
            buttonProps={{
              ...elbProps,
              type: 'submit',
              onClick: handleSubmit(onSubmit),
              'data-elbaction': TRACKING_ACTION.REGISTRATION.PREVIOUS_EDUCATION,
            }}
          />
        </StudentQuestion.Section>
      </Container>
    </StudentQuestion>
  );
};

export default PreviousEducation;
